// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import Metric from '../state/metric';
import OpenPipProgramsDealerCriteria from './open-pip-programs-dealer-criteria';
import OpenPipProgramsIncludeFullyCompleteCriteria from './open-pip-programs-include-fully-complete-criteria';
import OpenPipProgramsMetricCriteria from './open-pip-programs-metric-criteria';
import OpenPipProgramsPipNumberCriteria from './open-pip-programs-pip-number-criteria';
import OpenPipProgramsPipStatusCriteria from './open-pip-programs-pip-status-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';
import pipStatuses from '../state/pip-statuses';

const OpenPipProgramsReportCriteria = props =>
    <div className='open-pips-criteria'>
        <div className='criteria-container'>
            <div className='dealer-criteria-container'>
                <OpenPipProgramsDealerCriteria
                    onDealerSelect={props.onDealerSelect}
                    onSelectAllDealers={props.onSelectAllDealers}
                    selectedAccounts={props.selectedAccounts}
                    selectedDealers={props.selectedDealers}
                />
            </div>
            <div className='other-criteria-container'>
                <div className='other-criteria-shrink-container'>
                    <OpenPipProgramsPipNumberCriteria
                        onPipNumberInputChange={props.onPipNumberInputChange}
                        pipNumber={props.pipNumber}
                    />
                    <OpenPipProgramsIncludeFullyCompleteCriteria
                        includeFullyComplete={props.includeFullyComplete}
                        onIncludeFullyCompleteInputChange={props.onIncludeFullyCompleteInputChange}
                    />
                    <OpenPipProgramsPipStatusCriteria
                        onPipStatusSelect={props.onPipStatusSelect}
                        onSelectAllPipStatuses={props.onSelectAllPipStatuses}
                        pipStatuses={props.pipStatuses}
                    />
                    <OpenPipProgramsMetricCriteria
                        metric={props.metric}
                        onMetricSelect={props.onMetricSelect}
                        onSelectAllPipMetrics={props.onSelectAllPipMetrics}
                    />
                </div>
            </div>
        </div>
        <ReportCriteriaFooter
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onCriteriaReset}
            onRunReport={props.onCreateReport}
            showReport={true}
        />
    </div>;

OpenPipProgramsReportCriteria.displayName = 'OpenPipProgramsReportCriteria';
OpenPipProgramsReportCriteria.propTypes = {
    canRunReport: PropTypes.bool.isRequired,
    includeFullyComplete: PropTypes.bool.isRequired,
    metric: PropTypes.instanceOf(Metric).isRequired,
    onCreateReport: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onIncludeFullyCompleteInputChange: PropTypes.func.isRequired,
    onMetricSelect: PropTypes.func.isRequired,
    onPipNumberInputChange: PropTypes.func.isRequired,
    onPipStatusSelect: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    onSelectAllPipMetrics: PropTypes.func.isRequired,
    onSelectAllPipStatuses: PropTypes.func.isRequired,
    pipNumber: PropTypes.string.isRequired,
    pipStatuses: PropTypes.instanceOf(pipStatuses).isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default OpenPipProgramsReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/components/open-pip-programs-report-criteria.js